export default __webpack_public_path__ + "static/media/new-ar.830f0db0.svg";